module.exports = __webpack_public_path__ + "img/TrustBy_Netcare.67798f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Netcare.jpg
// module id = 608
// module chunks = 5